import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/vendor_users/Page";

export const PATH = "/vendors/settings/vendor_users";

function VendorUsersSetting() {
	return (
		<>
			<NskHead title="設定" />
			<Component />
		</>
	);
}

export default VendorUsersSetting;
